module.exports = __webpack_public_path__ + "img/shogi_2021_pack_4.e9028f53.png";